import styled from "styled-components/macro";

export const StyledPlansContainer = styled.div`
  width: 100%;
  ${"" /* width: 100%; */}
`;

export const StyledHeader = styled.header`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0px;
  ${"" /* margin: 40px 0; */}
  & h2 {
    font-size: 32px;
    font-style: normal;
    font-weight: 600;
    line-height: 48px;
    letter-spacing: 0em;
    color: #575e68;
    margin: 16px 0;
  }
  & p {
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 100%;
    color: #575e68;
  }
`;

export const StyledCardsList = styled.ul`
  max-width: 100%;

  list-style: none;

  display: flex;
  justify-content: space-evenly;
  gap: 25px;

  padding: 0px;
  margin: 40px auto;

  flex-wrap: wrap;
`;

export const StyledCardContainer = styled.div`
  position: relative;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 32px;

  max-width: 360px;
  min-width: 300px;
  height: 330px;

  background: #ffffff;
  border: 1px solid #ebedee;
  border-radius: 8px;
`;

export const StyledBadge = styled.p`
  position: absolute;
  top: 8px;
  right: 27px;

  padding: 4px 8px;

  background: #008060;
  border-radius: 4px;

  font-weight: 600;
  font-size: 12px;
  line-height: 18px;
  color: #f4f6f8;

  margin: 10px 0px;
`;

export const StyledCardHeader = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0px;
`;

export const StyledCardTitle = styled.p`
  text-transform: uppercase;
  font-size: 16px;
  line-height: 100%;

  color: #575e68;

  margin-bottom: 16px;
`;
export const StyledCardPrice = styled.p`
  display: flex;
  align-items: baseline;
  font-size: 14px;
  line-height: 21px;
  & span {
    font-weight: 600;
    font-size: 40px;
    line-height: 40px;

    color: #111111;

    margin: 0 8px;
  }
`;

export const StyledCardBilled = styled.p`
  font-size: 14px;
  line-height: 21px;

  color: #575e68;
  opacity: 0.5;

  margin: 8px 0;
`;

export const StyledCardSessions = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px;
  margin: 40px 0;
  font-weight: 600;
  font-size: 16px;
  line-height: 100%;
  color: #575e68;
  & span {
    margin-right: 10px;
  }
`;

export const StyledCardButton = styled.button`
  &:hover {
    cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
  }
  width: 100%;

  background: ${(props) => (props.disabled ? "#939DD6" : "#6270c6")};
  border: 1px solid #939dd6;
  border-radius: 4px;
  padding: 16px 0;

  text-transform: uppercase;
  font-weight: 600;
  font-size: 16px;
  line-height: 100%;
  text-align: center;

  color: #fcfcfd;
`;
